(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["back-button"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-back-button]');
    if (!button) return;

    // Only go back if the previous page was on this store; otherwise go home.
    const referrer = document.referrer;
    if (referrer && referrer.indexOf(window.location.host) !== -1 && window.history.length > 1) {
      window.history.back();
    } else {
      window.location.href = button.dataset.fallbackUrl;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
